import { BsFillGeoAltFill } from "react-icons/bs";
import { useSelector } from "react-redux";
import Spinner from "../spinner";
import "./index.css";

const AbouUs = () => {
  const configs = useSelector((state) => state.User.configsAdmin);

  if (!configs)
    return (
      <>
        <Spinner />
      </>
    );

  return (
    <>
      <div className="fondo">
        <div>
          <h5 style={{'fontWeight':'600'}}>
            {!configs.business ? "Servicios Informáticos Bragado" : configs.business}
          </h5>
          <h6 style={{'fontWeight':'300'}}>
            {!configs.slogan ? "Servicios y Productos de computación y tecnología" : configs.slogan}
          </h6>
          <div>
            <button
              className="btn btn-link letra"
              style={{'textDecoration':'none'}}
              onClick={() =>{
                window.open(
                  "https://www.google.com/maps?q=bragado"
                )
              }
              }
            >
              <BsFillGeoAltFill /> { configs.address } - { configs.city } - {configs.province} - {configs.country}
            </button>
          </div>          
{/*           <h6 style={{'fontWeight':'300'}}>
            {!configs.horario
              ? "Los pedidos están sujetos a horario"
              : configs.horario}
          </h6> */}
        </div>
      </div>
    </>
  );
};

export default AbouUs;
